// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"main-container_mainContainer__1t9pJ","todosContainer":"main-container_todosContainer__2k-wu"};